import React from "react";
import { Paper, Text, Flex, Container, useMantineTheme } from "@mantine/core";

export default function CenterLoadingOverlay({ content }) {
  const theme = useMantineTheme();
  const backgroundColor = theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white;
  
  return (
    <Container
      fluid
      style={{
        minHeight: "calc(100vh - 100px)", // Leave space for footer
        backgroundColor: backgroundColor,
        zIndex: 2000,
        padding: 0,
      }}
    >
      <Flex style={{ minHeight: "calc(100vh - 100px)", width: '100%' }} align="center" justify="center">
        {content}
      </Flex>
    </Container>
  );
}
